import SeedlyngLogo from '@/assets/branding/seedlyng/seedlyng-horizontal.png';

const colors = {
  // Brand colors
  brand_primary: '#FF5733',
  brand_primary_hover: '#E04D2E',
  brand_primary_highlight: '#F5B1A3',
  brand_primary_mid: '#D6725C',
  brand_primary_dark: '#B83214',
  brand_secondary: '#2f6cce',
  brand_accent_start: '#FF6A45',
  brand_accent_end: '#F2A93B',
  brand_accent_light_start: '#FFF0EA',
  brand_accent_light_end: '#FFEFD6',
  brand_complementary_accent: 'rgb(61,221,255)',
  brand_auth_gradient_mid: '#2f6cce',
  brand_auth_gradient_end: '#B83214',
  brand_auth_warp_mid: '#D6725C',
};

export default {
  name: 'SD171',
  allowPersonalCourses: false,
  logo: SeedlyngLogo,
  colors,
};
